import * as Factory from 'factory.ts'
import faker from 'faker'

import { type SpendingCardAlert } from '../../models'

export const SpendingCardAlertMock =
  Factory.Sync.makeFactory<SpendingCardAlert>({
    id: Factory.each(() => faker.random.number()),
    uuid: Factory.each(() => faker.random.uuid()),
    created_at: Factory.each(() => faker.date.past(10).toISOString()),
    updated_at: Factory.each(() => faker.date.past(10).toISOString()),
    last_changed_by: Factory.each(() => faker.random.number()),
    threshold: Factory.each(() => parseFloat(faker.commerce.price())),
    is_enabled: true,
  })
